import { Component } from '@angular/core';
import { CatalogoPage } from 'src/app/models/entidad-page.interface';
import { HttpPaginacion, Paginar } from 'src/app/models/http-paginacion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
@Component({
  selector: 'app-antibioticos',
  templateUrl: './antibioticos.component.html',
  styleUrls: ['./antibioticos.component.scss']
})
export class AntibioticosComponent {
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 120;
  antibioticosPageInformacion: HttpPaginacion<CatalogoPage> | undefined;
  antibioticoPage: CatalogoPage[] = [];
  constructor(private adiministradorService: AdministradorService){
    this.obtenerInformacion(1);
  }

  obtenerInformacion(page: number): void{
    this.adiministradorService.antibioticos(page)
    .subscribe({
      next: (resp) => { 
        this.antibioticosPageInformacion = resp;
        this.antibioticoPage = resp.data;
        
        this.first = (resp.current_page - 1) * resp.per_page;
        this.rows = resp.per_page;
        this.totalRecords = resp.total;
      },
      error: (err) => console.log(err) 
    })
  }

  onPageChange(event: any) {
    const paginar: Paginar = <Paginar>event;
    const paginaActual = paginar.page + 1;
    this.obtenerInformacion(paginaActual);
     
  }
  exportExcel(): void{}
}
